module.exports = __webpack_public_path__ + "img/whatsapp.a864ffbe.svg";